// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-tag + .el-tag[data-v-79dd2a70] {\n  margin-left: 0;\n  margin-top: 10px;\n}", ""]);
// Exports
module.exports = exports;
